import { CloseOutlined, FullscreenExitOutlined, FullscreenOutlined } from '@ant-design/icons';
import Button from 'antd/es/button/button';

import React, { CSSProperties, useState } from 'react';
import Draggable from 'react-draggable';

import { DraggableModalPropsType } from 'src/app/components/DraggableModal/draggable-modal.config';
import styles from 'src/app/components/DraggableModal/DraggableModal.module.scss';

const DraggableModal: React.FC<DraggableModalPropsType> = ({
  children,
  headerText,
  onClickClose,
  id,
  className,
  contentClassName,
  position,
  isHeaderOn = true,
  extraContent,
  style,
  defaultPosition,
  isDrawModal = false,
  isResizable = false,
  enableFullscreen = false,
}) => {
  const [isFullSize, setIsFullSize] = useState(false);

  const fullSizeStyle: CSSProperties = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
  };

  const contentStyle: CSSProperties = {
    ...style,
    width: isFullSize ? '100vw' : style?.width,
    height: isFullSize ? '100vh' : style?.height,
    overflow: isResizable && !isFullSize ? 'auto' : style?.overflow,
    resize: isResizable && !isFullSize ? 'both' : undefined,
  };

  return (
    <Draggable
      handle="strong"
      bounds="body"
      defaultClassName={className || styles.drag}
      defaultPosition={
        defaultPosition
          ? {
              x: defaultPosition.x,
              y: defaultPosition.y,
            }
          : {
              x: 100,
              y: 100,
            }
      }
      position={isFullSize ? { x: 0, y: 0 } : undefined}
      disabled={false}
      onMouseDown={(e) => e.stopPropagation()}
    >
      <div id={id} style={isFullSize ? fullSizeStyle : {}}>
        <strong
          className="popup-header"
          onDoubleClick={enableFullscreen ? () => setIsFullSize((prev) => !prev) : undefined}
        >
          <div className="popup-title-container">
            <div
              className={isDrawModal ? '' : 'popup-title-container'}
              style={{
                display: 'flex',
                alignItems: 'center',
                maxWidth: isDrawModal ? '350px' : '700px',
                marginTop: '5px',
                marginBottom: '5px',
              }}
              title={headerText}
            >
              <p
                className="popup-title"
                style={{
                  flex: isDrawModal ? '1 1 auto' : undefined, // allow grow/shrink only when drawing
                  minWidth: isDrawModal ? 0 : undefined, // <-- crucial for flex
                  whiteSpace: isDrawModal ? 'nowrap' : undefined,
                  overflow: isDrawModal ? 'hidden' : undefined,
                  textOverflow: isDrawModal ? 'ellipsis' : undefined,
                  margin: 0, // reset <p> default margins if needed
                }}
              >
                {headerText}
              </p>
            </div>
          </div>
          <div>
            {enableFullscreen && (
              <Button
                onClick={() => setIsFullSize((prev) => !prev)}
                icon={isFullSize ? <FullscreenExitOutlined /> : <FullscreenOutlined />}
              />
            )}
            <Button onClick={onClickClose} icon={<CloseOutlined />} />
          </div>
        </strong>

        <div className={contentClassName || styles.dragContent} style={contentStyle}>
          {children}
        </div>
      </div>
    </Draggable>
  );
};

export default DraggableModal;
